<template>
  <div class="row">
    <div class="col-12">
      <card class="card-stats livestream-card" :show-footer-line="true">
        <div class="row">
          <div class="col-5">
            <div class="info-icon text-center icon-primary">
              <i class="tim-icons icon-video-66"></i>
            </div>
          </div>
          <div class="col-7">
            <div class="numbers">
              <h3 class="card-title">Live Stream</h3>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div v-if="embedCode" class="livestream-container" v-html="embedCode"></div>
            <div v-else class="livestream-placeholder">
              <span>No live stream configured</span>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
const axios = require('axios');

export default {
  data() {
    return {
      embedCode: ''
    };
  },
  async mounted() {
    try {
      var res = await axios.get('/api/livestream-embed');
      this.embedCode = (res.data && res.data.embedCode) || '';
    } catch (e) {
      console.error('Failed to load live stream embed:', e);
    }
  }
};
</script>

<style scoped>
.livestream-card {
  height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
}
.livestream-card >>> .card-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
.livestream-container {
  flex: 1;
  margin-top: 1rem;
  position: relative;
  min-height: 0;
}
.livestream-container >>> iframe {
  max-height: 100%;
}
.livestream-placeholder {
  flex: 1;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.4;
}
</style>
